import { render, staticRenderFns } from "./BaseFlyout.vue?vue&type=template&id=4da67f33"
import script from "./BaseFlyout.vue?vue&type=script&lang=ts"
export * from "./BaseFlyout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports